import {
  WSCard,
  WSElement,
  WSSectionToolbar
} from "@wingspanhq/fe-component-library";
import { IWorkLog, WorkLogStatus } from "@wingspanhq/payments/dist/interfaces";
import React, { useMemo } from "react";
import { StepItem, Steps } from "../../../shared/components/Steps";

type Props = {
  workLog?: IWorkLog;
  shimmer?: boolean;
};

export const WorkLogStatusStepperPayeeView: React.FC<Props> = props => {
  const steps: StepItem[] = useMemo(() => {
    const isApproved = props.workLog?.status === WorkLogStatus.Approved;

    return [
      {
        title: "In-progress",
        status: isApproved ? "Complete" : "Active"
      },
      {
        title: "Submitted",
        status: isApproved ? "Complete" : "Pending"
      }
    ];
  }, [props.workLog?.status]);

  return (
    <WSElement>
      <WSSectionToolbar title="Work log steps" />
      <WSCard shimmer={props.shimmer}>
        <Steps steps={steps} />
      </WSCard>
    </WSElement>
  );
};
